/*
    This file is a shim to make rule utilities available globally.  We concat it with the bundle
    after the bundle is already made.
*/
var handle = rules.handle;
var getTables = rules.getTables;
var r = rules.r;
var indexOf = rules.indexOf;
var stringLength = rules.stringLength;
var strReplace = rules.strReplace;
var getCharCodeAt = rules.getCharCodeAt;
var toUpperCase = rules.toUpperCase;
var toLowerCase = rules.toLowerCase;
var capitalize = rules.capitalize;
var toTitleCase = rules.toTitleCase;
var trim = rules.trim;
var objToString = rules.objToString;
var stringSubstring = rules.stringSubstring;
var isNumeric = rules.isNumeric;
var sleep = rules.sleep;
var getQuoteProductFieldValue = rules.getQuoteProductFieldValue;
var setQuoteProductFieldValue = rules.setQuoteProductFieldValue;
var factorial = rules.factorial;
var padStringLeft = rules.padStringLeft;
var dateAdd = rules.dateAdd;
var formatDate = rules.formatDate;
var getLocation = rules.getLocation;
var getNestedConfigurator = rules.getNestedConfigurator;
var toQueryString = rules.toQueryString;

var _if = rules._if;
var _while = rules._while;
var _for = rules._for;
var Loop = rules.Loop;

var RestClient = rules.RestClient;
var OracleCpqClient = rules.OracleCpqClient;
var SalesForceClient = rules.SalesForceClient;
var KineticClient = rules.KineticClient;